module.exports = __webpack_public_path__ + "img/blank.5d5798a0.png";